import { Component, OnDestroy } from '@angular/core';
import { LoadingService } from '@core/loading.service';

@Component({
  selector: 'app-interim',
  imports: [],
  templateUrl: './interim.component.html',
  styleUrl: './interim.component.scss'
})
export class InterimComponent implements OnDestroy {
  constructor(
    private loadingService: LoadingService,
  ) {
    this.loadingService.present();
  }

  ngOnDestroy(): void {
    this.loadingService.dismiss();
  }
}
